module.exports = __webpack_public_path__ + "static/21-acd113c9515d559cebb00d05a2082fcf.jpg";